import React, { Component, Fragment } from 'react';
import ScrollLock from 'react-scrolllock';

import Header from '../NewProfile/Header';
import SideBarContent from '../SideBar/SideBarContent';
import Button from '../../artzu-ui/src/Button';

class AccountComponent extends Component {
  render() {
    const { id, history, status, email } = this.props;
    return (
      <div className="intro container new-course">
        {/introapp/.test(window.location.href) ? null : (
          <Header
            persistentTitle
            title="Account"
            back
            onClick={() => {
              history.goBack();
            }}
          />
        )}
        <div className="new-course__body__footer--mobile">
          <div className="new-course__body__buttons">
            {/introapp/.test(window.location.href) ? (
              <a href={`/introapp/${Number(id) - 1}`}>
                <Button
                  color="#414141"
                  label="Previous"
                  size="xl"
                  padding="0"
                />
              </a>
            ) : (
              <Button
                color="#414141"
                label="Previous"
                size="xl"
                padding="0"
                onClick={() => history.push(`/intro/${Number(id) - 1}`)}
              />
            )}
            {/introapp/.test(window.location.href) ? (
              <a href={`/introapp/${Number(id) + 1}`}>
                <Button primary label="Next" size="xl" padding="0" />
              </a>
            ) : (
              <Button
                primary
                label="Next"
                size="xl"
                padding="0"
                onClick={() => history.push(`/intro/${Number(id) + 1}`)}
              />
            )}
          </div>
        </div>
        <ScrollLock>
          <div className="intro__content new-course__container">
            <div className="intro__sidebar new-course__sidebar">
              <SideBarContent status={status} signedIn={email} />
            </div>
            <div
              className="new-course__body"
              style={
                /introapp/.test(window.location.href)
                  ? { marginTop: '0' }
                  : null
              }>
              <div className="intro__content--container">
                <div className="intro__content__title">
                  Connect to Uber Driver Account{' '}
                </div>
                <div className="intro__content__para">
                  If you haven’t connected your Uber Driver account yet to
                  your Autzu account, you will be asked to do so before you
                  can make a booking.
                </div>
                <div>
                  <img
                    src="https://autzu-team.s3.us-east-2.amazonaws.com/Intro/connect+Uber+account.png"
                    alt="connect uber account"
                    className="intro__content__img"
                  />
                </div>
                <div className="intro__content__para">
                  This step is necessary so that information about your
                  Uber earnings can be managed in your Autzu account.
                </div>
                <br />
                <div className="intro__content__title">
                  Bank Account Details
                </div>
                <div className="intro__content__para">
                  You will need to fill in your bank details in your
                  profile so that you will be able to receive the weekly
                  payments from Autzu.
                </div>
                <div>
                  <img
                    src="https://autzu-team.s3.us-east-2.amazonaws.com/Intro/bank+account+details.png"
                    alt="bank account details"
                    className="intro__content__img"
                  />
                </div>
                <div className="intro__content__title">
                  Uber Driver Account
                </div>
                <div className="intro__content__para">
                  If this is your first time driving with Uber, you will
                  need to accept some agreements before starting. You may
                  also need to opt in to receive tips from riders - you can
                  see more in Notifications in the Driver app.
                </div>
                <br />
                <br />
                <br />
              </div>
              <div className="new-course__body__footer--desktop intro__content__footer--desktop">
                <div className="new-course__body__buttons intro__content__footer--buttons">
                  <Button
                    color="#414141"
                    label="Previous"
                    size="xl"
                    onClick={() =>
                      history.push(`/intro/${Number(id) - 1}`)
                    }
                  />
                  <Button
                    primary
                    label="Next"
                    size="xl"
                    onClick={() =>
                      history.push(`/intro/${Number(id) + 1}`)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </ScrollLock>
      </div>
    );
  }
}

export default AccountComponent;



// WEBPACK FOOTER //
// ./src/components/Intro/AccountComponent.js